import { GlobalConstants } from '../../../../core/constants/global-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { Option } from './interface/option';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { Table } from 'primeng/table';
import { AreaMappingRFQMaintenanceTableColumn } from './interface/area-mapping-rfq-maintenance-table-column';
import { AreaMappingRFQMaintenanceTableData } from './interface/area-mapping-rfq-maintenance-table-data';
import { PageInfo } from 'src/app/core/models/page-info';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { AreaMappingRFQMaintenanceGetRequest } from './interface/area-mapping-rfq-maintenance-get-request';
import { throwError } from 'rxjs';
import { AreaMappingRFQMaintenanceService } from '../../service/area-mapping-rfq-maintenance.service';
import { AreaMappingRFQMaintenanceSaveRequest } from './interface/area-mapping-rfq-maintenance-save-request';
import { FacilityService } from 'src/app/core/services/facility.service';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-area-mapping-rfq-maintenance',
  templateUrl: './area-mapping-rfq-maintenance.component.html',
  styleUrls: ['./area-mapping-rfq-maintenance.component.scss']
})
export class AreaMappingRFQMaintenanceComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.AreaMappingRFQMaintenance;
  currentLang: string = this.laasSetting.language;
  // Status for the Query Form is open or not
  isSearchFormOpen = true;
  // The formGroup for the Query Form part
  searchFormGroup: FormGroup;

  // Options for Country dropdown list
  countryOptions: Option[] = [];
  // All options for City dropdown list
  allCityOptions: Option[] = [];
  // Options for Form City dropdown Muliselect list
  formCityOptions: Option[] = [];
  // Options for table City dropdown Multiselect list
  tableCityOptions: Option[] = [];
  // All options for City dropdown list
  allAssignmentDistrictOptions: Option[] = [];
  // Options for Form Assignment District Multiselect list
  formAssignmentDistrictOptions: Option[] = [];
  // Options for table Assignment District Multiselect list
  tableAssignmentDistrictOptions: Option[] = [];

  // Status for the loading circle on the table
  isLoading: boolean = false;
  // Status for enabling a user to edit the data on the table
  isInEditMode: boolean = false;
  // The table for table part
  @ViewChild('table') table!: Table;
  // All the columns of the table have
  tableColumns: AreaMappingRFQMaintenanceTableColumn[] = [
    { field: 'seqNo', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.SeqNo', sort: true },
    { field: 'facility', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.Facility', sort: true },
    { field: 'country', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.Country', sort: true },
    { field: 'city', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.City', sort: true },
    { field: 'assignmentDistrictId', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.AssignmentDistrict', sort: true },
    { field: 'rfqCountry', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.RFQCountry', sort: true },
    { field: 'rfqCity', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.RFQCity', sort: true },
    { field: 'rfqAreaCode', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.RFQAreaCode', sort: true },
    { field: 'rfqAreaName', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.RFQAreaName', sort: true },
    { field: 'citySeqNo', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.CitySeqNo', sort: true },
    { field: 'createUser', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.CreateUser', sort: true },
    { field: 'createDt', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.CreateDt', sort: true },
    { field: 'updateUser', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.UpdateUser', sort: true },
    { field: 'updateDt', header: 'AreaMappingRFQMaintenance.Table.ColumnHeader.UpdateDt', sort: true }
  ];
  // The columns user choose to display
  selectedTableColumns: AreaMappingRFQMaintenanceTableColumn[] = [];
  // Current data on the table
  tableData: AreaMappingRFQMaintenanceTableData[] = [];
  // Backup data when data retrieved from the back-end
  backupTableData: AreaMappingRFQMaintenanceTableData[] = [];
  // User current selected row on the table
  selectedRow: AreaMappingRFQMaintenanceTableData | null;
  // User last selected row on the table
  previousSelectedRow: AreaMappingRFQMaintenanceTableData | null;

  // Records for user's operation on the table
  newAreaMappingRFQList: AreaMappingRFQMaintenanceTableData[] = [];
  updatedAreaMappingRFQList: AreaMappingRFQMaintenanceTableData[] = [];
  deletedAreaMappingRFQSeqNoList: number[] = [];

  // For data key to distinguish the added rows on the table
  newDataKeyId: number = 0;
  // Table paging info
  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };
  // Table sorting info
  sortOrder: SortOrder = {
    property: "SeqNo",
    direction: -1
  };

  constructor(
    private injector: Injector,
    private formBuilder: FormBuilder,
    private facilityService: FacilityService,
    private commonDataService: CommonDataService,
    private areaMappingRFQMaintenanceService: AreaMappingRFQMaintenanceService
  ) {
    super(injector);
    this.searchFormGroup = this.formBuilder.group({
      country: null,
      citySeqNo: null,
      assignmentDistrictId: null,
      rfqCountry: null,
      rfqCity: null,
      rfqAreaCode: null,
      rfqAreaName: null,
    })

    this.selectedTableColumns = this.tableColumns;
    this.selectedRow = null;
    this.previousSelectedRow = this.selectedRow;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.commonDataService.getCountry().subscribe({
      next: (response) => {
        for (const country of response) {
          if (this.laasSetting.language == GlobalConstants.defaultLanguage) {
            this.countryOptions.push({
              label: `${country.countryCode} - ${country.countryName}`,
              value: country.countryCode
            })
          }
          else {
            this.countryOptions.push({
              label: `${country.countryCode} - ${country.countryEnName}`,
              value: country.countryCode
            })
          }
        }
      }
    })

    this.facilityService.getCityOptions().subscribe({
      next: (response) => {
        this.allCityOptions = this.createCityOptionList(response);
      }
    })

    this.commonDataService.getAssignmentDistrictBy().subscribe({
      next: (response) => {
        this.allAssignmentDistrictOptions = this.createAssignmentDistrictOption(response);
      }
    })
  }

  @Input() get selectedColumns(): AreaMappingRFQMaintenanceTableColumn[] {
    return this.selectedTableColumns;
  }

  set selectedColumns(cols: AreaMappingRFQMaintenanceTableColumn[]) {
    // Filter display columns
    this.selectedTableColumns = this.tableColumns.filter(col => cols.includes(col));
  }

  formSelectedCountryChanged(event: { value: string }) {
    this.searchFormGroup.controls['citySeqNo'].setValue(null);
    this.searchFormGroup.controls['assignmentDistrictId'].setValue(null);
    this.updateFormDropdownOption(event.value);
  }

  searchBtnClick(): void {
    this.isSearchFormOpen = false;
    this.isInEditMode = false;
    this.isLoading = true;
    this.pageInfo.pageIndex = 0;
    this.table.first = 0;
    this.sendSearchRequest();
  }

  sendSearchRequest(): void {
    this.restoreData();
    const getRequest: AreaMappingRFQMaintenanceGetRequest = this.createGetRequestBean();

    this.areaMappingRFQMaintenanceService.getAreaMappingRFQ(getRequest).subscribe({
      next: (response) => {
        this.table.cancelRowEdit(this.selectedRow);
        if (!isNullOrEmpty(response)) {

          //Update table
          if (response.content.length > 0) {
            this.tableData = deepCopy(response.content)!;
            this.backupTableData = deepCopy(this.tableData)!;
            this.selectedRow = this.tableData[0];

            if (!isNullOrEmpty(this.selectedRow)) {
              this.updateTableDropdownOption(this.selectedRow.country!)
            }
          }
          else {
            this.tableData = [];
            this.backupTableData = [];
            this.selectedRow = null;
          }

          this.previousSelectedRow = this.selectedRow;
          this.updateTableHighlight(this.selectedRow);
          if (this.isInEditMode) {
            this.table.initRowEdit(this.selectedRow);
          }

          // Change page Info
          this.pageInfo.totalRecords = response.totalElements;
          this.pageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;
        }
        else {
          throwError(response);
        }
      },
      error: (response) => {
        this.tableData = [];
        this.backupTableData = [];
        this.selectedRow = null;
        this.previousSelectedRow = this.selectedRow;
        this.pageInfo.totalRecords = 0;
        this.pageInfo.totalPages = 0;
        // Handle Error Msg
        // Find error list of assignment district
        let errorCode = response.error.errorCode;
        let category = response.error.category;
        this.commonDataService.getErrorCodes(this.laasSetting.language, category).subscribe({
          next: (errorList) => {
            // find error that has the errorCode in  errorList
            let matchedError = errorList.find((error: any) => error.errorCode == errorCode)
            this.toastService.error(matchedError.errorMsg)
          }
        })
      },
      complete: () => {
        this.isLoading = false;
      }
    })
  }

  addNewRow(): void {

    if (!this.isUserInputValid(this.previousSelectedRow))
      return;

    // Add a new row to table's first row
    this.tableData.splice(0, 0, {
      seqNo: null, facility: this.laasSetting.facility, country: null,
      rfqCountry: null, city: null, citySeqNo: null, rfqCity: null,
      assignmentDistrictId: null, rfqAreaCode: null, rfqAreaName: null,
      createDt: new Date(), createUser: this.userService.userInfo.userName,
      updateDt: new Date(), updateUser: this.userService.userInfo.userName,
      dataKey: `--${this.newDataKeyId++}`
    })

    this.clearTableEdit();

    if (!isNullOrEmpty(this.selectedRow)) {
      this.updateTableDropdownOption(this.selectedRow!.country!)
    }

    this.table.initRowEdit(this.selectedRow);
  }

  deleteSelectedRow(): void {
    this.confirmationService.confirm({
      header: this.translateService.instant('AreaMappingRFQMaintenance.Confirm.Header'),
      message: this.translateService.instant('AreaMappingRFQMaintenance.Confirm.Delete'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.table.cancelRowEdit(this.selectedRow);

        if (!isNullOrEmpty(this.selectedRow)) {
          const selectedRowIndex = this.tableData.indexOf(this.selectedRow!);
          if (selectedRowIndex > -1) {
            if (!isNullOrEmpty(this.tableData[selectedRowIndex].seqNo)) {
              this.addToDeletedList(this.tableData[selectedRowIndex].seqNo!)
            }
          }

          // Remove deleted row from table
          this.tableData.splice(selectedRowIndex, 1);

          // Change selected row
          if (selectedRowIndex != this.tableData.length) {
            // Change user current selected row to the next row of the deleted row
            this.selectedRow = this.tableData[selectedRowIndex];
          }
          else if (selectedRowIndex == this.tableData.length) { // Deleted row is the last row of the current page
            // Change user current selected row to the previous row of the deleted row
            this.selectedRow = this.tableData[selectedRowIndex - 1];
          }
          else {
            this.selectedRow = null;
          }

          this.previousSelectedRow = this.selectedRow;
          this.updateTableHighlight(this.selectedRow);

          if (!isNullOrEmpty(this.selectedRow)) {
            this.updateTableDropdownOption(this.selectedRow!.country!)
          }

          this.table.initRowEdit(this.selectedRow);
          this.toastService.success(this.translateService.instant("AreaMappingRFQMaintenance.Toast.DeleteSuccess"));
        }
      }
    })
  }

  saveChanges(): void {
    this.confirmationService.confirm({
      header: this.translateService.instant('AreaMappingRFQMaintenance.Confirm.Header'),
      message: this.translateService.instant('AreaMappingRFQMaintenance.Confirm.Save'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.isLoading = true;

        if (!this.isUserInputValid(this.selectedRow)){
          this.isLoading = false;
          return;
        }

        // Check user's operations on the table
        this.checkNewAndUpdatedRow();
        const savedData: AreaMappingRFQMaintenanceSaveRequest = {
          newAreaMappingRFQList: this.newAreaMappingRFQList,
          updatedAreaMappingRFQList: this.updatedAreaMappingRFQList,
          deletedAreaMappingRFQSeqNoList: this.deletedAreaMappingRFQSeqNoList
        }

        this.areaMappingRFQMaintenanceService.saveAreaMappingRFQChanges(savedData).subscribe({
          next: () => {
            this.table.cancelRowEdit(this.selectedRow);
            this.isInEditMode = false;

            this.sendSearchRequest();
            this.toastService.success(this.translateService.instant("AreaMappingRFQMaintenance.Toast.SaveSuccess"));
          },
          error: (response) => {
            this.isLoading = false;
            this.newAreaMappingRFQList = [];
            this.updatedAreaMappingRFQList = [];
            this.toastService.error(this.translateService.instant('AreaMappingRFQMaintenance.Toast.SaveFail') + response.status);
          }
        });
      }
    })
  }

  restoreTableDate(): void {
    this.confirmationService.confirm({
      header: this.translateService.instant('AreaMappingRFQMaintenance.Confirm.Header'),
      message: this.translateService.instant('AreaMappingRFQMaintenance.Confirm.Restore'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.restoreData();

        // Update table to last saved data
        this.tableData = deepCopy(this.backupTableData)!;
        this.clearTableEdit();
        if (!isNullOrEmpty(this.selectedRow)) {
          this.updateTableDropdownOption(this.selectedRow!.country!)
        }
        this.table.initRowEdit(this.selectedRow);
        this.toastService.success(this.translateService.instant('AreaMappingRFQMaintenance.Toast.RestoreSuccess'))
      }
    })
  }

  switchEditMode(): void {
    if (this.isInEditMode) {
      this.confirmationService.confirm({
        header: this.translateService.instant('AreaMappingRFQMaintenance.Confirm.Header'),
        message: this.translateService.instant('AreaMappingRFQMaintenance.Confirm.Exit'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.isInEditMode = false;
          this.restoreData();

          // Update table to last saved data
          this.tableData = deepCopy(this.backupTableData)!;
          this.clearTableEdit();
          this.toastService.success(this.translateService.instant('AreaMappingRFQMaintenance.Toast.ExitSuccess'))
        }
      })
    }
    else {
      this.isInEditMode = true;
      if (!isNullOrEmpty(this.selectedRow)) {
        this.updateTableDropdownOption(this.selectedRow!.country!);
        this.table.initRowEdit(this.selectedRow);
      }
    }
  }

  onRowSelect(rowData: AreaMappingRFQMaintenanceTableData): void {
    if (this.isInEditMode) {
      // Keep the selectedRow variable is pointing at the user's selected row
      // Whether is select or deselect
      this.selectedRow = rowData;

      // Reselect after user click on the same row
      if (this.previousSelectedRow != null && this.previousSelectedRow.dataKey === this.selectedRow.dataKey) {
        this.updateTableHighlight(this.previousSelectedRow);
        return;
      }

      // Change the current selected row to the user's selected row
      if (this.isUserInputValid(this.previousSelectedRow)) {
        this.table.cancelRowEdit(this.previousSelectedRow);
        this.previousSelectedRow = this.selectedRow;
        this.updateTableDropdownOption(this.selectedRow.country!);
        this.table.initRowEdit(this.selectedRow);
      }else{
        this.selectedRow = this.previousSelectedRow;
        this.updateTableHighlight(this.selectedRow);
      }
    }
    else {
      this.previousSelectedRow = this.selectedRow;
    }
  }

  onTablePageChanging(event: { first: number, rows: number }) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / event.rows;
    this.isLoading = true;
    this.sendSearchRequest();
  }

  onTableSorting(event: { field: string, order: number }) {
    if (this.tableData.length != 0) {
      this.sortOrder.property = event.field;
      this.sortOrder.direction = event.order;
      this.isLoading = true;
      this.sendSearchRequest();
    }
  }

  tableSelectedCountryChanged(event: { value: string }, rowData: AreaMappingRFQMaintenanceTableData) {
    this.clearRelatedRowValue(rowData);
    this.updateTableDropdownOption(event.value);
  }

  // Cancel current table's row editing
  private clearTableEdit() {
    this.table.cancelRowEdit(this.selectedRow);
    this.selectedRow = this.tableData[0];
    this.previousSelectedRow = this.selectedRow;

    //Avoid the highlighted part leave on the previous row
    this.updateTableHighlight(this.selectedRow);
  }

  private restoreData(): void {
    // Clear user changed action
    this.newDataKeyId = 0;
    this.newAreaMappingRFQList = [];
    this.updatedAreaMappingRFQList = [];
    this.deletedAreaMappingRFQSeqNoList = [];

    this.table.resetScrollTop();
  }

  private createGetRequestBean(): AreaMappingRFQMaintenanceGetRequest {
    return {
      country: this.searchFormGroup.value.country,
      citySeqNo:
        this.searchFormGroup.value.citySeqNo?.length === 0 ? null : this.searchFormGroup.value.citySeqNo,
      assignmentDistrictId:
        this.searchFormGroup.value.assignmentDistrictId?.length === 0 ? null : this.searchFormGroup.value.assignmentDistrictId,
      rfqCountry: this.searchFormGroup.value.rfqCountry,
      rfqCity: this.searchFormGroup.value.rfqCity,
      rfqAreaCode: this.searchFormGroup.value.rfqAreaCode,
      rfqAreaName: this.searchFormGroup.value.rfqAreaName,
      pageIndex: this.pageInfo.pageIndex,
      pageSize: this.pageInfo.pageSize,
      sortOrder: this.sortOrder
    }
  }

  private checkNewAndUpdatedRow(): void {
    let saveDataIndex = 0;

    if (saveDataIndex < this.tableData.length) {
      // Check if any added row by dataKey property
      // Added row's dataKey format : --id
      for (const tableData of this.tableData) {
        if (tableData.dataKey[0] != '-') {
          break;
        }
        this.addToNewAreaMappingRFQList(tableData);
        saveDataIndex++;
      }

      // Reverse for maintain order of user adding new row
      this.newAreaMappingRFQList.reverse();

      // Compare backup table data to current table data
      for (const backupData of this.backupTableData) {
        if (this.deletedAreaMappingRFQSeqNoList.indexOf(backupData.seqNo!) == -1) {
          if (JSON.stringify(this.tableData[saveDataIndex]) != JSON.stringify(backupData)) {
            this.addToUpdateList(this.tableData[saveDataIndex]);
          }
          saveDataIndex++;
        }
      }
    }
  }

  // Control the selection highlighting back to the row
  private updateTableHighlight(currentRow: AreaMappingRFQMaintenanceTableData | null): void {
    if (!currentRow) {
      return;
    }
    this.table.selection = currentRow;
    this.table.selectionKeys = {};
    this.table.selectionKeys[currentRow.dataKey] = 1;
    this.table.tableService.onSelectionChange();
  }

  private addToNewAreaMappingRFQList(rowData: AreaMappingRFQMaintenanceTableData): void {
    rowData.citySeqNo = Number(rowData.city);
    this.newAreaMappingRFQList.push(rowData);
  }

  private addToUpdateList(rowData: AreaMappingRFQMaintenanceTableData): void {
    rowData.citySeqNo = isNullOrEmpty(rowData.city) ? null : Number(rowData.city);
    rowData.updateUser = this.userService.userInfo.userName;
    rowData.updateDt = new Date();
    this.updatedAreaMappingRFQList.push(rowData);
  }

  private addToDeletedList(seqNo: number): void {
    this.deletedAreaMappingRFQSeqNoList.push(seqNo);
  }

  /**
   * Clear related row value when user edit country on the table
   */
  private clearRelatedRowValue(rowData: AreaMappingRFQMaintenanceTableData) {
    rowData.city = null;
    rowData.assignmentDistrictId = null;
    rowData.citySeqNo = null;
  }

  /**
   * Update form dropdown list option that binded with country
   */
  private updateFormDropdownOption(country: string): void {
    this.updateFormCityOption(country);
    this.updateFormAssignmentDistrictOption(country);
  }

  /**
   * Update form city dropdown list option that binded with country
   */
  private updateFormCityOption(country: string): void {
    this.commonDataService.getCityByCountry(country).subscribe({
      next: (response) => {
        this.formCityOptions = this.createCityOptionList(response);
      }
    })
  }

  /**
   * Update form assignment district dropdown list option that binded with country
   */
  private updateFormAssignmentDistrictOption(country: string): void {
    this.commonDataService.getAssignmentDistrictBy(undefined, country).subscribe({
      next: (response) => {
        this.formAssignmentDistrictOptions = this.createAssignmentDistrictOption(response);
      }
    })
  }

  /**
   * Update table dropdown list option that binded with country
   */
  private updateTableDropdownOption(country: string): void {
    this.updateTableCityOption(country);
    this.updateTableAssignmentDistrictOption(country);
  }

  /**
   * Update table city dropdown list option that binded with country
   */
  private updateTableCityOption(country: string) {
    this.commonDataService.getCityByCountry(country).subscribe({
      next: (response) => {
        this.tableCityOptions = this.createCityOptionList(response);
      }
    })
  }

  /**
   * Update table assignment district dropdown list option that binded with country
   */
  private updateTableAssignmentDistrictOption(country: string): void {
    this.commonDataService.getAssignmentDistrictBy(undefined, country).subscribe({
      next: (response) => {
        this.tableAssignmentDistrictOptions = this.createAssignmentDistrictOption(response);
      }
    })
  }

  /**
   * Create city options from response
   */
  private createCityOptionList(response: any): Option[] {
    let cityOptions: Option[] = [];
    for (const city of response) {
      if (this.laasSetting.language == GlobalConstants.defaultLanguage) {
        cityOptions.push({
          label: `${city.seqNo} - ${city.name}`,
          value: city.seqNo.toString()
        })
      }
      else {
        cityOptions.push({
          label: `${city.seqNo} - ${city.enName}`,
          value: city.seqNo.toString()
        })
      }
    }
    return cityOptions;
  }

  /**
   * Create assignment district options from response
   */
  private createAssignmentDistrictOption(assignmentDistrictList: any): Option[] {
    let assignmentDistrictOptions: Option[] = [];
    for (const assignmentDistrict of assignmentDistrictList) {
      assignmentDistrictOptions.push({
        label: `${assignmentDistrict.assignmentDistrictId} - ${assignmentDistrict.districtName}`,
        value: assignmentDistrict.assignmentDistrictId
      })
    }
    return assignmentDistrictOptions;
  }

  private isUserInputValid(rowData: AreaMappingRFQMaintenanceTableData | null): boolean {
    if (rowData) {
      if (!rowData.country ||
        !rowData.rfqCountry ||
        !rowData.city ||
        !rowData.rfqCity ||
        !rowData.rfqAreaCode||
        !rowData.rfqAreaName) {
        this.toastService.warn(this.translateService.instant("CarSequenceMaintenance.Toast.EmptyDataError"));
        return false;
      }
    }
    return true;
  }
}
